export const AUTO_SCROLL_ZONE = 120; // px от края
export const AUTO_SCROLL_MAX_SPEED = 3;
export const SCROLL_PADDING = 60;
